import type { ComponentPublicInstance } from 'vue';

/**
 * Hides a Quasar QPopupProxy ref by name.
 * Used across many components with q-date/q-time popup proxies.
 */
export function hidePopupProxy(
  vm: ComponentPublicInstance,
  refName: string
): void {
  (vm.$refs[refName] as any)?.hide();
}
